export const MEDIA_UPDATE_MEDIAOBJECTS = 'MEDIA_UPDATE_MEDIAOBJECTS';
export const MEDIA_UPDATE_MEDIAOBJECTS_SUCCESS = 'MEDIA_UPDATE_MEDIAOBJECTS_SUCCESS';
export const APP_UPDATE_APPOBJECTS = 'APP_UPDATE_APPOBJECTS';
export const APP_UPDATE_APPOBJECTS_SUCCESS = 'APP_UPDATE_APPOBJECTS_SUCCESS';
export const AUTH_SET_INITIAL_STATE = "AUTH_SET_INITIAL_STATE";

//AUTH
export const AUTH_UPDATE_AUTHOBJECTS = "AUTH_UPDATE_AUTHOBJECTS";
export const AUTH_UPDATE_AUTHOBJECTS_SUCCESS = "AUTH_UPDATE_AUTHOBJECTS_SUCCESS";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_START = "AUTH_LOGIN_START";

//CONFIG
export const CONFIG_UPDATE_CONFIGOBJECTS = "CONFIG_UPDATE_CONFIGOBJECTS";
export const CONFIG_UPDATE_CONFIGOBJECTS_SUCCESS = "CONFIG_UPDATE_CONFIGOBJECTS_SUCCESS";

//CART
export const CART_UPDATE_CARTOBJECTS_SUCCESS = "CART_UPDATE_CARTOBJECTS_SUCCESS";
export const CART_SET_INITIAL_STATE = "CART_SET_INITIAL_STATE";
export const CART_UPDATE_CARTOBJECTS = "CART_UPDATE_CARTOBJECTS";

//PROFILE
export const PROFILE_UPDATE_PROFILEOBJECTS = "PROFILE_UPDATE_PROFILEOBJECTS";
export const PROFILE_UPDATE_PROFILEOBJECTS_SUCCESS = "PROFILE_UPDATE_PROFILEOBJECTS_SUCCESS";
export const PROFILE_SET_INITIAL_STATE = "PROFILE_SET_INITIAL_STATE";